import { getBrowserId } from './browserId'
import { collectFingerprint } from './fingerprint'
import { encryptForBackend } from './backendCrypto'

// Mirrors webapp/src/utils/events.ts and multibanco-validator/src/lib/analytics.ts
// — same AppEventSchema shape. The payload is encrypted client-side before it
// ever leaves the browser; /api/graphql just relays the already-
// encrypted body to the shared backend. Unlike the public-facing apps,
// backoffice is authenticated (SuperTokens), so events are enriched with the
// operator's session userId when available.

export type EventType = 'page' | 'action'

export type Page = 'BackofficeView' | 'Login'

export type Components = 'sidebar_nav' | 'register_message_type_form' | 'manage_tenant_form' | 'manage_platform_form' | 'manage_email_type_form' | 'manage_source_form' | 'submit_entry_form'

export type EventName =
  | 'backoffice_view'
  | 'login'
  | 'sign_out'
  | 'register_message_type_submit'
  | 'register_platform_submit'
  | 'register_tenant_submit'
  | 'update_tenant_submit'
  | 'update_platform_submit'
  | 'register_email_type_submit'
  | 'update_email_type_submit'
  | 'register_source_submit'
  | 'update_source_submit'
  | 'submit_entry_report'

interface ManualFieldsEvent {
  event_type: EventType
  event_name: EventName
  page?: Page
  component?: Components

  field_1_key?: string
  field_1_value?: string
  field_2_key?: string
  field_2_value?: string
  field_3_key?: string
  field_3_value?: string
  field_4_key?: string
  field_4_value?: string
}

async function getSessionFields(): Promise<{ user_is_logged_in?: boolean; user_ext_user_id?: string }> {
  try {
    const Session = (await import('supertokens-auth-react/recipe/session')).default
    const exists = await Session.doesSessionExist()
    if (!exists) return { user_is_logged_in: false }
    const userId = await Session.getUserId()
    return { user_is_logged_in: true, user_ext_user_id: userId }
  } catch {
    return {}
  }
}

export const trackEvent = async (manualFields: ManualFieldsEvent): Promise<void> => {
  try {
    const fingerprint = await collectFingerprint()
    const sessionFields = await getSessionFields()
    const finalEvent = {
      device_platform: 'web',
      url: window.location.href,
      browser_id: getBrowserId(),
      fingerprint,
      ...sessionFields,
      ...manualFields,
    }

    const password = process.env.NEXT_PUBLIC_ENCRYPTION_PASSWORD ?? ''
    const encrypted = await encryptForBackend(finalEvent, password)

    await fetch('/api/graphql', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(encrypted),
    })
  } catch (error) {
    console.log('Error at trackEvent \n', error)
  }
}
